<ng-template #thisModalForm role="document" let-modal>

  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="thisFormCancel()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="thisFormSubmitAttempt()" [formGroup]="thisForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      @if (progressInformationShow) {
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label class="form-label text-right"></label>
              <div class="alert border-0 {{alertColourProgress}}" role="alert">
                <strong>Information</strong> - <span [innerHtml]="progressInformation" ></span>
              </div>
            </div>
          </div>
        </div>
      }
              
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="rentalTariffId-field" class="form-label text-right">Rental Tariff</label>
            <select
              class="form-select"
              name="rentalTariffId-field"
              id="rentalTariffId-field"
              formControlName="rentalTariffId"
              [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['rentalTariffId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("rentalTariffId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-4">
          <div class="mb-3">
            <label for="setupFee-field" class="form-label">Setup Fee</label>
            <input type="number" id="setupFee-field" class="form-control text-end" placeholder="" formControlName="setupFee" data-lpignore="true" [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['setupFee'].errors }" />
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
        <div class="col-4">
          <div class="mb-3">
            <label for="recurringFee-field" class="form-label">Recurring Fee</label>
            <input type="number" id="recurringFee-field" class="form-control text-end" placeholder="" formControlName="recurringFee" data-lpignore="true" [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['recurringFee'].errors }" />
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
        <div class="col-4">
          <div class="mb-3">
            <label for="recurringTypeId-field" class="form-label text-right">Recurring Type</label>
            <select
              class="form-select"
              name="recurringTypeId-field"
              id="recurringTypeId-field"
              formControlName="recurringTypeId"
              [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['recurringTypeId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("recurringTypeId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="feeChargeTypeId-field" class="form-label text-right">Fee Charge Type</label>
            <select
              class="form-select"
              name="feeChargeTypeId-field"
              id="feeChargeTypeId-field"
              formControlName="feeChargeTypeId"
              [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['feeChargeTypeId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("feeChargeTypeId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="simChargeTypeId-field" class="form-label text-right">SIM Charge Type</label>
            <select
              class="form-select"
              name="simChargeTypeId-field"
              id="simChargeTypeId-field"
              formControlName="simChargeTypeId"
              [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['simChargeTypeId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("simChargeTypeId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>







      <!--
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="tariffName-field" class="form-label">Tariff Name</label>
            <input type="text" id="tariffName-field" class="form-control" placeholder="" formControlName="tariffName" data-lpignore="true" [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['tariffName'].errors }" />
            @if(formOfThis['tariffName'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{tariffNameMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="billingServiceTypeId-field" class="form-label text-right">Service</label>
            <select
              class="form-select"
              name="billingServiceTypeId-field"
              id="billingServiceTypeId-field"
              formControlName="billingServiceTypeId"
              [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['billingServiceTypeId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("billingServiceTypeId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="tariffTypeId-field" class="form-label text-right">Product Type</label>
            <select
              class="form-select"
              name="tariffTypeId-field"
              id="tariffTypeId-field"
              formControlName="tariffTypeId"
              [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['tariffTypeId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("tariffTypeId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="currencyTypeId-field" class="form-label text-right">Currency</label>
            <select
              class="form-select"
              name="currencyTypeId-field"
              id="currencyTypeId-field"
              formControlName="currencyTypeId"
              [ngClass]="{ 'is-invalid': thisFormSubmitted && formOfThis['currencyTypeId'].errors }"
            >
              <option selected></option>
              @for (object of getDropdownDataObjectArray("currencyTypeId"); track object.id) {
                <option [ngValue]="object.id">{{object.description}}</option>    
              }
            </select>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
              
      <div class="row">
        <div class="col-12">
          <div class="form-check form-switch form-switch-md">
            <label class="form-check-label" for="active-field">Active</label>
            <input class="form-check-input" type="checkbox" role="switch" id="active-field" formControlName="active">
          </div>
        </div>
      </div>
      -->

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="thisFormCancel()">Close</button>
        <button type="submit" class="btn btn-success" id="add-btn">Submit</button>
      </div>
    </div>
  </form>    
</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalFormClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
